import axios from 'axios'

import config from '../../config'

const updateInspectionSubtype = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/InspectionSubtypes`
  return axios.put(url, data)
}

export default updateInspectionSubtype
